import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsCreatedPayload } from '../payloads/projectsCreatedPayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildProjectsCreatedInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsCreatedPayload(payload);
  const { projects_created } = parsedPayload.data.attributes.aggregate;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: projects_created.current ?? 0,
          trend: projects_created.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
